import Vue from 'vue'
import App from './App.vue'
import { Carousel, CarouselItem } from 'element-ui'
import 'normalize.css'
import 'element-ui/lib/theme-chalk/index.css';
import { vscrollCenter } from '@/utils/directives';
import VConsole from 'vconsole';
import axios from 'axios';

// 初始化 Vconsole
// const vConsole = new VConsole();

Vue.directive('vscrollCenter', vscrollCenter); // 焦点指令

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  axios,
  render: h => h(App)
}).$mount('#app')
